<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="deps"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%;"
    >
      <el-table-column
        type="selection"
        width="50"
      >
      </el-table-column>
      <el-table-column
        type="index"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="Name"
        label="字典名称"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="Number"
        label="字典代码"
        width="300"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="CreateBy"
        label="创建者"
        width=""
        sortable
      >
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar"
    >
      <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length===0"
      >批量删除</el-button>
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item
          label="字典名称"
          prop="Name"
        >
          <el-input
            v-model="editForm.Name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典代码"
          prop="Number"
        >
          <el-input
            v-model="editForm.Number"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-button
          type="primary"
          @click.native.prevent="addRow(1)"
        >新增字典明细</el-button>
        <el-table
          :data="entry"
          highlight-current-row
          @selection-change="selsChange"
          style="width: 100%;"
        >
          <el-table-column
            prop="MainInfo"
            label="字典值"
            width=""
            sortable
          >
            <template scope="scope">
              <el-input
                size="mini"
                :disabled="scope.row.CreateUserID !=null"
                autosize
                type="textarea"
                v-model="scope.row.Number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="MainInfo"
            label="字典名称"
            width=""
            sortable
          >
            <template scope="scope">
              <el-input
                size="mini"
                :disabled="scope.row.CreateUserID !=null"
                autosize
                type="textarea"
                v-model="scope.row.Name"
              ></el-input>
            </template>
          </el-table-column>

        </el-table>

      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item
          label="字典名称"
          prop="Name"
        >
          <el-input
            v-model="addForm.Name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典代码"
          prop="Number"
        >
          <el-input
            v-model="addForm.Number"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-button
          type="primary"
          @click.native.prevent="addRow(1)"
        >新增字典明细</el-button>
        <el-table
          :data="entry"
          highlight-current-row
          @selection-change="selsChange"
          style="width: 100%;"
        >
          <el-table-column
            prop="MainInfo"
            label="字典值"
            width=""
            sortable
          >
            <template scope="scope">
              <el-input
                size="mini"
                :disabled="scope.row.CreateUserID !=null"
                autosize
                type="textarea"
                v-model="scope.row.Number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="MainInfo"
            label="字典名称"
            width=""
            sortable
          >
            <template scope="scope">
              <el-input
                size="mini"
                :disabled="scope.row.CreateUserID !=null"
                autosize
                type="textarea"
                v-model="scope.row.Name"
              ></el-input>
            </template>
          </el-table-column>

        </el-table>

      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import { getDictionaryListPage, removeDictionary, editDictionary, addDictionary } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: ''
      },
      deps: [],
      entry: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],//列表选中列

      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        Number: [
          { required: true, message: '请输入部门编码', trigger: 'blur' }
        ]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Number: '',
        Name: '',
        Enabled: false,
      },

      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {

        Name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        Number: [
          { required: true, message: '请输入部门编码', trigger: 'blur' }
        ]

      },
      //新增界面数据
      addForm: {
        Number: '',
        Name: '',
        Enabled: '',
      }

    }
  },
  methods: {
    addRow(isadd) {//新增一行
      this.entry.push({ Id: 0, Number: '', Name: '' })
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function(row, column) {
      return (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget();
    },
    //获取用户列表
    handleget() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      //NProgress.start();
      getDictionaryListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.deps = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {

        this.listLoading = true;
        //NProgress.start();
        let para = { id: row.Id };
        removeDictionary(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          //NProgress.done();
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }

          this.handleget();
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit() {
      this.entry = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.entry = row.Entry;
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.entry = [];
      this.addForm = {
        CreateBy: '',
        Number: '',
        Name: '',
        Enabled: 'true',
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {


            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            var tmp = this.entry;
            for (let i = 0; i < tmp.length; i++) {
              if (tmp[i].Name.length == 0 || tmp[i].Number.length == 0) {
                this.$message.error('处理意见不能为空噢！');
                this.addLoading = false;
                return;
              }
            }
            para.Entry = this.entry;

            para.ModifyTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');

            editDictionary(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.handleget();
              } else {
                this.editLoading = false;

                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });

              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);


            var tmp = this.entry;
            for (let i = 0; i < tmp.length; i++) {
              if (tmp[i].Name.length == 0 || tmp[i].Number.length == 0) {
                this.$message.error('处理意见不能为空噢！');
                this.addLoading = false;
                return;
              }
            }
            para.Entry = this.entry;
            para.CreateTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: '用户信息为空，先登录',
                type: 'error'
              });
              _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
            }


            addDictionary(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.handleget();
              }
              else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
                this.addLoading = false;

              }

            });

          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: '该功能未开放',
        type: 'warning'
      });
    }
  },
  mounted() {
    this.handleget();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}

</script>

<style scoped>
</style>
